import React, {Fragment} from 'react';
import {Popup} from 'components';
import {includes, toggle, useNamedSelector} from 'helpers';
import {store} from 'store';

export function PlanSettings({goal}) {
  const {preferences = {}} = useNamedSelector('goals.plan', {id: goal.id, context: 'goals'});
  return (
    <Fragment>
      <b>Display</b>
      <Popup.Menu>
        <Popup.Menu.Checkbox onClick={() => toggleCompleted('milestones', preferences)} checked={includes(preferences.completed, 'milestones')}>
          Completed milestones
        </Popup.Menu.Checkbox>
        <Popup.Menu.Checkbox onClick={() => toggleCompleted('activities', preferences)} checked={includes(preferences.completed, 'activities')}>
          Completed activities
        </Popup.Menu.Checkbox>
      </Popup.Menu>
    </Fragment>
  );
}

export function PlanSorting({goal}) {
  const {preferences = {}} = useNamedSelector('goals.plan', {id: goal.id, context: 'goals'});
  return (
    <Fragment>
      <b>Sort by</b>
      <Popup.Menu>
        <Popup.Menu.Radio onClick={() => sort({ value: 'newest', id: goal.id })} checked={preferences.sort.name == 'newest'}>Newest first</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => sort({ value: 'oldest', id: goal.id })} checked={preferences.sort.name == 'oldest'}>Oldest first</Popup.Menu.Radio>
        { preferences.sort.name == 'customOrder' &&
          <Popup.Menu.Radio checked>Custom</Popup.Menu.Radio>
        }
      </Popup.Menu>
    </Fragment>
  );
}

function sort({ value, id }) {
  store.dispatch({
    type: 'UI_SETTING',
    module: 'goalPlan',
    key: 'sort',
    id,
    value,
  });
}

function toggleCompleted(entity, preferences) {
  store.dispatch({
    type: 'UI_SETTING',
    module: 'goalPlan',
    key: 'completed',
    value: toggle(preferences.completed, entity, { separator: ', ' }),
  });
}
